import React from 'react';
import { useTranslation } from 'react-i18next';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useLanguagesContext } from '../../context/lng-context';

export default function LanguageSelector(): JSX.Element {
  const { t, i18n } = useTranslation();

  const languages = useLanguagesContext();

  return (
    <PopupState variant="popover" popupId="languageSelector">
      {(popupState) => (
        <>
          <IconButton
            sx={{ ml: 3 }}
            aria-label="change language"
            color="inherit"
            /* eslint-disable-next-line react/jsx-props-no-spreading */
            {...bindTrigger(popupState)}
          >
            <Tooltip title={<Typography>{t('changeLanguage')}</Typography>} arrow>
              <GTranslateIcon fontSize="large" />
            </Tooltip>
          </IconButton>
          {/* eslint-disable-next-line react/jsx-props-no-spreading */}
          <Menu {...bindMenu(popupState)}>
            {languages.map(({ value, label }) => (
              <MenuItem
                key={value}
                sx={{
                  textTransform: 'capitalize',
                }}
                selected={i18n.language === value}
                onClick={() => {
                  if (i18n.language !== value) {
                    i18n.changeLanguage(value);
                    popupState.close();
                  }
                }}
              >
                {label}
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </PopupState>
  );
}
